import { EffectsCommandMap } from 'dva';
import { ConnectState } from '@/models/connect';
import { FUtil, FServiceAPI } from '@freelog/tools-lib';
import { history } from '@@/core/history';
import type {
  ChangeAction,
  OnMount_Page_Action,
  OnUnmount_Page_Action,
  OnChange_ShowPage_Action,
} from './types';
import { initialState } from './initialState';

export const pageEffects = {
  *onMount_Page({ payload }: OnMount_Page_Action, { select, call, put }: EffectsCommandMap) {
    const { nodeManagerPage }: ConnectState = yield select(
      ({ nodeManagerPage }: ConnectState) => ({
        nodeManagerPage,
      }),
    );

    const params: Parameters<typeof FServiceAPI.Node.details>[0] = {
      nodeId: payload.nodeID,
    };

    const {
      ret,
      errCode,
      msg,
      data: data_nodeDetails,
    }: {
      ret: number;
      errCode: number;
      msg: number;
      data: {
        nodeId: number;
        ownerUserId: number;
        status: number;
        nodeLogo: string;
        nodeName: string;
        nodeTitle: string;
        nodeShortDescription?: string;
        nodeThemeId: string;
        nodeDomain: string;
        coverImage?: string;
        exhibitMatchTags?: string[];
      };
    } = yield call(FServiceAPI.Node.details, params);
    if (!data_nodeDetails || data_nodeDetails.ownerUserId !== FUtil.Tool.getUserIDByCookies()) {
      history.replace(FUtil.LinkTo.exception403());
      return;
    }

    if (data_nodeDetails.status === -1) {
      history.replace(FUtil.LinkTo.nodeDeleted({ nodeID: payload.nodeID }));
      return;
    }

    if ((data_nodeDetails.status & 4) === 4) {
      history.replace(FUtil.LinkTo.nodeFreeze({ nodeID: payload.nodeID }));
      return;
    }

    yield put<ChangeAction>({
      type: 'change',
      payload: {
        nodeId: payload.nodeID,
        nodeCover: data_nodeDetails?.nodeLogo || '',
        nodeName: data_nodeDetails?.nodeName || '',
        nodeTitle: data_nodeDetails?.nodeTitle || '',
        nodeUrl: FUtil.Format.completeUrlByDomain(data_nodeDetails?.nodeDomain || ''),
        testNodeUrl: FUtil.Format.completeUrlByDomain(
          (data_nodeDetails?.nodeDomain || '') + '.t',
        ),
        nodeThemeId: data_nodeDetails.nodeThemeId || '',
        nodeInfoState: 'loaded',
        showPage: payload.showPage,
        setting_nodeIntroduction: data_nodeDetails?.nodeShortDescription || '',
        setting_nodeInfo: {
          cover: data_nodeDetails?.nodeLogo || '',
          title: data_nodeDetails?.nodeTitle || '',
          introduction: data_nodeDetails?.nodeShortDescription || '',
          limitation:
            data_nodeDetails.status === 1
              ? 'public'
              : data_nodeDetails.status === 2
              ? 'private'
              : 'pause',
          limitationMessage: '',
          coverImage: data_nodeDetails?.coverImage ?? '',
          exhibitMatchTags: data_nodeDetails?.exhibitMatchTags ?? [],
        },
        node_limitation:
          data_nodeDetails.status === 1
            ? 'public'
            : data_nodeDetails.status === 2
            ? 'private'
            : 'pause',
      },
    });
  },
  *onUnmount_Page({}: OnUnmount_Page_Action, { put }: EffectsCommandMap) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        ...initialState,
      },
    });
  },
  *onChange_ShowPage({ payload }: OnChange_ShowPage_Action, { put }: EffectsCommandMap) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        showPage: payload.value,
      },
    });
  },
};
